import React from 'react';
import moment from 'moment';
import shortid from 'shortid';

export default class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = { notifications: [], currentTime: new Date() };
  }
  componentWillMount() {
    window.Notifications = this;
    this.intervalId = setInterval(() => {
      this.setState({ currentTime: new Date() });
    }, 1000);
  }
  componentWillUnmount() {
    delete window.Notifications;
    clearInterval(this.intervalId);
  }
  add(notification) {
    const notifications = this.state.notifications;
    notifications.push(notification);
    this.setState({ notifications });
    setTimeout(() => {
      this.remove(notifications.length - 1);
    }, notification.expires - new Date());
  }
  remove(i) {
    const notifications = this.state.notifications;
    notifications.splice(i, 1);
    this.setState({ notifications });
  }
  render() {
    return (
      <div className="notifications column is-4">
        <div className="section">
          <p className="title">{moment(this.state.currentTime).format('D MMMM')}</p>
          <hr />
          <p className="subtitle">{moment(this.state.currentTime).format('HH:mm')}</p>
          {
            this.state.notifications.map((n, i) =>
              (<article key={shortid.generate()} className="message is-primary">
                <div className="message-header">
                  <p><i className={n.icon} /> {n.title} {moment(n.datetime).format('D MMM HH:mm')}</p>
                  <button className="delete" aria-label="delete" onClick={() => this.remove(i)} />
                </div>
                <div className="message-body">
                  {n.content}
                </div>
              </article>)
            )
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications.js